import {ActionReducer, State} from '@ngrx/store';
import {pobranoStoreSuccess} from './persist-store.actions';
import {zaladujStoreZSessionStorage} from '../../../init/store/init.actions';

/** Metareducer, który przechwytuje wszystkie akcje.
 * W przypadku złapania akcji 'pobranoStoreSuccess' stan store
 * podmieniany jest w całości na wartość przekazaną w akcji.
 */

export function restoreStoreState(reducer: ActionReducer<any>): ActionReducer<any> {
  return function restoreState(state: State<any>, action): ActionReducer<any> {
    const sessionStateKey = 'sessionState';

    if (pobranoStoreSuccess.type === action.type) {
      const {type, ...restoredState} = action;
      state = updateTokenInRestoredState(restoredState, getTokenFromState(state));
    }

    if (zaladujStoreZSessionStorage.type === action.type) {
      const sessionStateValue = sessionStorage.getItem(sessionStateKey);
      if (sessionStateValue) {
        try {
          return JSON.parse(sessionStateValue);
        } catch {
          sessionStorage.removeItem(sessionStateKey);
        }
      }
      setTimeout(() => {throw new Error('Brakuje parametrow url oraz brak session state')})
    }

    const nextState = reducer(state, action);
    if (getCorrelationIdFromState(nextState)) {
      sessionStorage.setItem(sessionStateKey, JSON.stringify(nextState));
    }
    return nextState;
  }
}

function getTokenFromState(state: any): string {
  const samoobsluga = {...state.samoobsluga};
  return samoobsluga.token;
}

function getCorrelationIdFromState(state: any): string | null {
  if (!state) return null
  const samoobsluga = {...state.samoobsluga};
  return samoobsluga ? samoobsluga.correlationId : null;
}

function updateTokenInRestoredState(restoredState: any, token: string): any {
  const samoobsluga = {...restoredState.samoobsluga};
  samoobsluga.token = token;
  return {...restoredState, ...{samoobsluga}};
}

